import { render, staticRenderFns } from "./UpdatePasswordWidget.vue?vue&type=template&id=14b060fc"
import script from "./UpdatePasswordWidget.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports